import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Carhireforoutstaioninmumbai() {



  const cardData = {
    keyword: " Car Hire for Outstation in Mumbai ",


"headingDescription": "Royal Route Cab offers reliable car hire for outstation travel in Mumbai, providing safe, comfortable, and affordable long-distance journeys across India. Whether you are planning a weekend getaway, family vacation, business trip, or pilgrimage tour, our professional drivers and well-maintained vehicles ensure a smooth and stress-free travel experience. We offer flexible car hire options including one-way drops, round trips, multi-city tours, and fully customized itineraries based on your travel needs. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Innova Crysta, Ertiga, and Tempo Travellers suitable for solo travelers, families, and large groups. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for car hire for outstation from Mumbai.",

"topPlaces": [
  {
    "title": "Goa",
    "description": "Goa is India’s most popular beach destination, famous for its golden coastline, vibrant nightlife, water sports, and Portuguese heritage. It is one of the top outstation road trip choices from Mumbai, offering scenic highway drives, coastal views, beach shacks, and a relaxed holiday atmosphere for families, couples, and groups."
  },
  {
    "title": "Lonavala",
    "description": "Lonavala is a beautiful hill station near Mumbai known for lush green valleys, waterfalls, caves, and pleasant weather. It is a perfect short-distance getaway ideal for monsoon trips, trekking, picnic outings, and peaceful nature breaks from city life."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill station in the Western Ghats known for strawberry farms, viewpoints, lakes, and cool climate. It is a popular family destination offering scenic drives, nature walks, and relaxing holiday experiences away from Mumbai’s busy environment."
  },
  {
    "title": "Pune",
    "description": "Pune is a major city in Maharashtra known for its educational institutions, IT hubs, forts, and cultural heritage. It is one of the most frequently traveled outstation routes from Mumbai for business trips, corporate travel, and weekend visits."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a sacred and cultural city located on the banks of the Godavari River, famous for Trimbakeshwar Jyotirlinga and vineyards like Sula. It is a major destination for both pilgrimage and leisure wine tourism from Mumbai."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India’s most important pilgrimage sites dedicated to Sai Baba. Devotees from all over the country travel here for blessings, making it one of the most popular outstation cab routes from Mumbai."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is known for its historical and cultural significance, especially the UNESCO World Heritage Ajanta and Ellora Caves. It is a key destination for heritage tourism and long-distance road trips from Mumbai."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal getaway near Mumbai known for clean beaches, forts, and peaceful surroundings. It is a popular short trip destination for families and groups looking for a quick beach holiday."
  },
  {
    "title": "Surat",
    "description": "Surat is a major commercial city in Gujarat known for its diamond industry and textile markets. It is frequently visited for business travel and intercity cab services from Mumbai."
  },
  {
    "title": "Ahmedabad",
    "description": "Ahmedabad is a vibrant city in Gujarat known for Sabarmati Ashram, cultural heritage, and modern development. It is a key outstation destination for both tourism and corporate travel from Mumbai."
  }
],






services: [
  {
    name: "Car Hire for Outstation Mumbai",
    description: "Car hire for outstation Mumbai offers reliable and comfortable travel for long-distance journeys across cities and states. This service is ideal for family trips, business travel, and weekend getaways. Well-maintained vehicles and professional drivers ensure safety and convenience. It guarantees a smooth and hassle-free travel experience."
  },
  {
    name: "Outstation Car Rental Mumbai",
    description: "Outstation car rental Mumbai provides flexible travel solutions for intercity and long-distance trips. Customers can choose from a wide range of vehicles based on their needs. Clean cars and experienced drivers enhance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Car Rental for Long Trip Mumbai",
    description: "Car rental for long trip Mumbai is designed for extended travel with comfortable vehicles and experienced chauffeurs. This service is ideal for road trips, family vacations, and business travel. Vehicles are maintained for highway performance. It ensures a safe and enjoyable journey."
  },
  {
    name: "Outstation Car Hire Mumbai",
    description: "Outstation car hire Mumbai offers convenient rental options for long-distance travel. This service includes one way and round trip packages. Flexible booking and transparent pricing enhance convenience. It ensures a smooth travel experience."
  },
  {
    name: "Intercity Car Rental Mumbai",
    description: "Intercity car rental Mumbai provides easy travel between cities with flexible pickup and drop options. This service is ideal for both business and personal travel. Customers can select vehicle types based on their needs. It ensures efficient and comfortable travel."
  },
  {
    name: "Outstation Car Booking Mumbai",
    description: "Outstation car booking Mumbai allows customers to reserve vehicles easily for long-distance journeys. Travelers can select pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Outstation Car Rental Price Mumbai",
    description: "Outstation car rental price Mumbai varies based on distance, vehicle type, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Outstation Car Fare Mumbai",
    description: "Outstation car fare Mumbai is designed to be competitive and affordable for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "One Way Outstation Car Mumbai",
    description: "One way outstation car Mumbai offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Round Trip Outstation Car Mumbai",
    description: "Round trip outstation car Mumbai provides complete travel solutions including return journeys. This service is ideal for vacations and business trips. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Cheap Outstation Car Rental Mumbai",
    description: "Cheap outstation car rental Mumbai offers budget-friendly options for long-distance travel without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Outstation Car Hire Mumbai",
    description: "Best outstation car hire Mumbai ensures top-quality vehicles and professional drivers for long-distance travel. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  },
  {
    name: "SUV Outstation Rental Mumbai",
    description: "SUV outstation rental Mumbai offers spacious and comfortable vehicles for family and group travel. SUVs provide extra space and better performance for long journeys. Ideal for long-distance travel. It ensures a comfortable experience."
  },
  {
    name: "Sedan Outstation Rental Mumbai",
    description: "Sedan outstation rental Mumbai is ideal for individuals and small families seeking affordable long-distance travel. Sedans offer smooth rides and good mileage. Professional drivers ensure safe travel. It ensures a pleasant journey."
  }
],

tableData: [
  ["Car Hire for Outstation Mumbai", "Outstation Car Rental Mumbai"],
  ["Car Rental for Long Trip Mumbai", "Outstation Car Hire Mumbai"],
  ["Intercity Car Rental Mumbai", "Outstation Car Booking Mumbai"],
  ["Outstation Car Rental Price Mumbai", "Outstation Car Fare Mumbai"],
  ["One Way Outstation Car Mumbai", "Round Trip Outstation Car Mumbai"],
  ["Cheap Outstation Car Rental Mumbai", "Best Outstation Car Hire Mumbai"],
  ["SUV Outstation Rental Mumbai", "Sedan Outstation Rental Mumbai"],
  ["Car Hire for Outstation Mumbai", "Outstation Car Rental Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Car Hire for Outstation in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers dependable car hire services for outstation travel from Mumbai, ideal for family trips, business travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance and interstate routes, ensuring safe driving and smooth travel."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way car hire, round-trip bookings, or multi-day travel packages based on your itinerary."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Car Hire Availability",
    WhyChoosedescription: "Our outstation car hire service in Mumbai is available 24/7, allowing flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for outstation car hire from Mumbai due to punctual service and reliable travel experience."
  }
]

};

const faqData = [
  { question: "Do you provide car hire for outstation in Mumbai?", answer: "Yes, Royal Route Cabs offers reliable car hire services for outstation travel from Mumbai." },
  { question: "What types of outstation travel options are available?", answer: "We provide one-way, round-trip, and multi-day car hire options." },
  { question: "Is car hire available 24 hours?", answer: "Yes, our outstation car hire service operates 24/7." },
  { question: "Which vehicles are available for outstation travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Are toll charges included in fare?", answer: "Toll charges are included or clearly mentioned during booking with no hidden costs." },
  { question: "Can I hire a car for long-distance travel?", answer: "Yes, we provide car hire for long-distance and interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." },
  { question: "Can I customize my travel plan?", answer: "Yes, we provide fully customizable outstation travel packages." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Patil",
    feedback: "Car hire for outstation travel in Mumbai with Royal Route Cabs was very reliable. The vehicle was clean, and the long journey felt comfortable and safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Shah",
    feedback: "Excellent outstation car hire experience from Mumbai. The service was punctual, the car was well-maintained, and the trip was smooth from start to finish.",
    rating: 5
  }
];












  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Hire for Outstation in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/car-hire-outstation-mumbai.jpg", // replace if needed
  "description": "Book car hire for outstation travel in Mumbai with Royal Route Cabs. Reliable intercity and long-distance taxi service with sedan, SUV, Innova, and luxury cars. Available for one-way and round-trip journeys with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/car-hire-outstation-mumbai"
  }
};




  return (
    <div>

<Helmet>
  <title>Car Hire for Outstation in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book car hire for outstation from Mumbai with Royal Route Cabs. Affordable long-distance travel with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 service."
  />

  <meta
    name="keywords"
    content="car hire for outstation mumbai, outstation car rental mumbai, car rental for long trip mumbai, outstation car hire mumbai, intercity car rental mumbai, outstation car booking mumbai, outstation car rental price mumbai, outstation car fare mumbai, one way outstation car mumbai, round trip outstation car mumbai, cheap outstation car rental mumbai, best outstation car hire mumbai, suv outstation rental mumbai, sedan outstation rental mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carhireforoutstaioninmumbai;